import React, { Component } from "react";
import {
  Grid,
  Hidden,
  Drawer,
  List,
  ListItem,
  Divider,
  ButtonBase,
  Avatar,
  ListItemIcon
} from "@material-ui/core";
import { Icon } from "@material-ui/core";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import style from "./style";
import LoginDrawer from "../LoginDrawer/LoginDrawer";
import ResetPasswordDrawer from "../ChefProfile/ResetPasswordDrawer";
import {
  getUserId,
  logoutUser,
  getIsChef,
  getChefStep,
  showBecomeMsg
} from "../../redux/auth";
import Button from "@material-ui/core/Button";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import { getChef, getUser } from "../../redux/user";
import LinearProgress from "@material-ui/core/LinearProgress";

class HeaderComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dinerHover: false,
      chefHover: false,
      blogHover: props.history && props.history.location && props.history.location.pathname && props.history.location.pathname.indexOf('booking') > -1 && props.history.location.pathname.indexOf('booking') < 0,
      loginHover: false,
      logoutHover: false,
      helpHover: false,
      helpSelected: false,
      dinerSelected: false,
      chefSelected: false,
      blogSelected: false,
      loginSelected: false,
      openDrawer: false,
      openDrawerMobile: false,
      openLoginDrawer: false,
      registerHover: props.history && props.history.location && props.history.location.pathname && props.history.location.pathname.indexOf('sign-up') > -1,
      showLogin: true,
      showForgotPassword: false,
      showSignUp: false,
      isChef: false,
      open: false,
      openPasswordDrawer: false,
    };
  }

  handleBtnClick = route => {
    this.toggleDrawer();

    switch (route) {
      case "diner":
        this.props.history.push("/diner");
        break;

      case "chef":
        this.props.history.push("/chef");
        break;

      case "login":
        this.props.history.push("/sign-in");
        break;

      case "register":
        this.props.history.push("/sign-up");
        break;

      case "blog":
        //this.props.history.push("/blog");
        const blogURL = window.location.protocol + "//" + window.location.host + "/blog";
        window.open(blogURL, "_blank");
        break;

      case "becomeChef":
        this.props.history.push("/home/become-chef");
        break;

      case "portfolio":
        this.props.history.push("/home/dashboard");
        break;

      case "saved":
        this.props.history.push("/home/saved");
        break;

      case "cancellation":
        this.props.history.push("/home/profile/cancelation-policy");
        break;

      case "subscription":
        this.props.history.push("/home/profile/subscription");
        break;

      case "bookings":
        if (this.props.isChef) {
          this.props.history.push("/home/chef-bookings");
        }
        else {
          this.props.history.push("/home/diner-bookings");
        }
        break;

      case "profile":
        this.props.history.push("/home/profile/edit-profile");
        break;

      /*case "inbox":
        this.props.history.push("/inbox");
        window.location.reload();
        break;*/

      case "schedule":
      case "chef-schedule":
        this.props.history.push("/home/chef-schedule");
        break;

      case "logout":
        this.logout();
        this.props.history.push("/");
        break;

      default:
        return;
    }
  };

  handleToggle = () => {
    this.setState({ open: !this.state.open }, () => {
      if (this.state.open) {
        this.setState({ showLogin: true, showForgotPassword: false, showSignUp: false });
      }
    });
  };

  handleLoginToggle = () => {
    this.setState({ showLogin: !this.state.showLogin }, () => {
      if (!this.state.showLogin) {
        this.setState({ showForgotPassword: true });
      }
      else {
        this.setState({ showForgotPassword: false, showSignUp: false });
      }
    });
  };

  togglePasswordDrawer = () => {
    this.setState({ openPasswordDrawer: !this.state.openPasswordDrawer });
  };

  closePasswordDrawer = () => {
    this.setState({ openPasswordDrawer: false });
  };

  handleSignUpToggle = () => {
    this.setState({
      showSignUp: !this.state.showSignUp
    }, () => {
      if (this.state.showSignUp) {
        this.setState({ showForgotPassword: false, showLogin: false });
      }
      else {
        this.setState({ showForgotPassword: false, showLogin: true });
      }
    });
  };

  handleClose = event => {
    if (this.anchorEl.contains(event.target)) {
      return;
    }

    this.setState({ open: false });
  };

  disableRedirection = route => {
    const redirectionDisabledRoutes = [
      "/home/dish-details",
      "/home/add-post",
      "/home/chef-search",
      "/home/dish-search",
      "/home/post-search",
      "/home/chef-profile",
      "/home/edit-profile",
      "/home/edit-portfolio"
    ];
    return redirectionDisabledRoutes.indexOf(route) > -1;
  };

  handleLogoClick = () => {
    const { isChef, history, userId } = this.props;
    const hasUserDetails = localStorage.hasOwnProperty("zg-cc-auth-userId");
    if (isChef && userId && hasUserDetails) {
      history.push("/home/dashboard");
    } else {
      if (userId && hasUserDetails) {
        history.push("/home/dashboard");
      } else {
        history.push("/");
      }
    }
  };

  setDefaultRoute = (pathName, search, state) => {
    const { history, userId, becomeChef, isChef, step, showBecomeChefMsg, dispatch } = this.props;

    if ((!userId || !step) && !becomeChef) {
      history.push(pathName);
    } else {
      if (becomeChef && pathName !== '/home/privacy-policy' && pathName !== '/home/terms-of-use') {
        history.push("/home/become-chef?step=1");
      } else if (isChef && step >= 0 && step <= 9) {
        if (pathName !== "/home/become-chef" && pathName !== "/home/dashboard") {
          let path = pathName;
          if (search) {
            path = `${pathName}${search}`;
          }
          history.push(path, state || {});
        } else {
          history.push(`/home/become-chef?step=${step}&showMsg=${showBecomeChefMsg === 'no' ? 'yes' : 'no'}`, state || {});
          if (showBecomeChefMsg) {
            dispatch(showBecomeMsg('yes'));
          }
        }
      } else if (isChef && step < 10) {
        // NotificationManager.info('Please finish giving the needed information so you can become a chef.', 'Become a chef', 4000);
        if (pathName === "/home/become-chef") {
          if (search) {
            history.push("/home/become-chef" + search, state || {});
          } else {
            history.push("/home/become-chef?step=" + step || 1);
          }
        } else {
          let path = pathName;
          if (search) {
            path = `${pathName}${search}`;
          }
          history.push(path, state || {});
        }
      } else {
        if (pathName !== "/home/dashboard") {
          history.push(pathName);
        }
      }
    }
  };

  componentDidMount() {
    const { dispatch, isChef, userId } = this.props;
    dispatch(getUserId());
    dispatch(getUser(userId));
    dispatch(getChef(userId));
    dispatch(getIsChef());
    dispatch(getChefStep());
    this.setState({ isChef });

    if (this.props.history) {
      if (this.props.history.location) {
        const {
          history: {
            location: { pathname: pathName, search, state }
          }
        } = this.props;
        if (!this.disableRedirection(pathName)) {
          this.setDefaultRoute(pathName, search, state);
        }
      }
    }

    const forceChangePassword = window.localStorage.getItem('ccZestyForceChangPassword');

    let openPasswordDrawer = false;
    if (forceChangePassword) {
      if (forceChangePassword !== 'false') {
        openPasswordDrawer = true;
      }
    }

    this.setState({ openPasswordDrawer: openPasswordDrawer });
  }

  toggleDrawer = () => {
    this.setState({ openDrawer: !this.state.openDrawer });
  };

  toggleDrawerMobile = () => {
    this.setState({ openDrawerMobile: !this.state.openDrawerMobile });
  };

  toggleLoginDrawer = () => {
    this.setState({ openLoginDrawer: !this.state.openLoginDrawer });
  };

  closeLoginDrawer = () => {
    this.setState({ openLoginDrawer: false, showLogin: true, showForgotPassword: false, showSignUp: false });
  };

  toggleHover = item => {
    switch (item) {
      default:
        return;

      case "diner":
        this.setState({ dinerHover: !this.state.dinerHover });
        break;

      case "chef":
        this.setState({ chefHover: !this.state.chefHover });
        break;

      case "blog":
        this.setState({ blogHover: !this.state.blogHover });
        break;

      case "login":
        this.setState({ loginHover: !this.state.loginHover });
        break;

      case "register":
        this.setState({ registerHover: !this.state.registerHover });
        break;

      case "help":
        this.setState({ helpHover: !this.state.helpHover });
        break;

      case "logout":
        this.setState({ logoutHOver: !this.state.logoutHover });
        break;
    }
  };

  logout = () => {
    const { dispatch } = this.props;
    dispatch(logoutUser());
    this.handleBtnClick("logout");
  };

  cancelChannelSignUp = () => {
    this.setState({
      openLoginDrawer: false,
      showSignUp: false,
      showForgotPassword: false,
      showLogin: true
    });
    this.props.removeChannel();
  };

  static getDerivedStateFromProps(props, state) {
    const forceChangePassword = window.localStorage.getItem('ccZestyForceChangPassword');

    if (props.location) {
      if (props.location.campaign && props.location.openSignUp) {
        return {
          openLoginDrawer: true,
          showSignUp: true,
          showLogin: false
        };
      }
    }

    if (forceChangePassword && forceChangePassword !== 'false') {
      return {
        openPasswordDrawer: true
      };
    } else {
      return {
        openPasswordDrawer: false
      };
    }

    return null;
  }

  render() {
    const { userId, isChef, step, chef, diner, history ,loading} = this.props;
    let menuWidth = 3;
    let logoWidth = 9;
    let logoTabWidth = 8;
    let profilePic = "/images/simple-user.webp";
    const { open } = this.state;
    const forceChangePassword = window.localStorage.getItem('ccZestyForceChangPassword');
    let openPasswordDrawer = this.state.openPasswordDrawer;

    if (forceChangePassword) {
      if (!!forceChangePassword && forceChangePassword === 'false') {
        openPasswordDrawer = false;
      } else {
        openPasswordDrawer = forceChangePassword;
      }
    }

    if (userId) {
      menuWidth = 8;
      logoWidth = 4;
      logoTabWidth = 4;
    }

    let user = isChef ? chef : diner;

    if (!!user && !!user.profilePic) {
      profilePic = user.profilePic;
    }

    let showPortfolio = (isChef && !!step && step >= 8) ? true : false;

    let pathName = undefined;
    if (history) {
      if (history.location) {
        const {
          history: {
            location: { pathname }
          }
        } = this.props;
        pathName=pathname;
      }
    }

    return (
      <div>
        {!userId && (
          <Grid container className='header-container' style={{
            position: 'fixed',
            width: '100%',
            left: 0,
            right: 0,
            zIndex: 999,
            backgroundColor: 'white',
            top: 0,
          }}>
            <div className="header-container-column">
              <Hidden smUp>
                <Grid item xs={4}>
                  <Icon style={style.menuIcon} onClick={this.toggleDrawer}>
                    menu
                  </Icon>
                </Grid>
              </Hidden>

              <Grid item xs={8} sm={4} md={5} lg={7}>

                <Hidden smUp>
                  <div style={{textAlign: 'right'}}>
                    <img
                      data-test-id={"cclogoup"}
                      src="/images/logo.webp"
                      alt="Cuisine Crafters"
                      style={style.logoMobile}
                      onClick={this.handleLogoClick}
                    />
                  </div>
                </Hidden>
                <Hidden xsDown>
                  <img
                  data-test-id={"cclogo"}
                    src="/images/logo.webp"
                    alt="Cuisine Crafters"
                    style={style.logo}
                    onClick={this.handleLogoClick}
                  />
                </Hidden>
              </Grid>
              <Hidden xsDown>
                <Grid item sm={8} md={7} lg={5} style={style.navMenu} alignItems={'center'} justify={'flex-end'} alignItems={'center'}>
                  <Link data-test-id={"linkdiner"}
                    to="/diner"
                    key="diner"
                    style={
                      this.state.dinerHover
                        ? style.navMenuItemHover
                        : style.navMenuItem
                    }
                    onMouseEnter={() => this.toggleHover("diner")}
                    onMouseLeave={() => this.toggleHover("diner")}
                  >
                    Diner
                  </Link>
                  <Link
                  data-test-id={"linkchef"}
                    to="/chef"
                    key="chef"
                    style={
                      this.state.chefHover
                        ? style.navMenuItemHover
                        : style.navMenuItem
                    }
                    onMouseEnter={() => this.toggleHover("chef")}
                    onMouseLeave={() => this.toggleHover("chef")}
                  >
                    Chef
                  </Link>

                  <a
                    href="https://cuisinecrafters.net/blog"
                    target="_blank"
                    key="blog"
                    style={
                      this.state.blogHover
                        ? style.navMenuItemHover
                        : style.navMenuItem
                    }
                    onMouseEnter={() => this.toggleHover("blog")}
                    onMouseLeave={() => this.toggleHover("blog")}
                  >
                    Blog
                  </a>
                  <Link
                    data-test-id={"loginbtn"}
                    to="/sign-in"
                    key="login"
                    style={
                      this.state.loginHover
                        ? {...style.navMenuItemHover, marginRight: 44}
                        : {...style.navMenuItem, marginRight: 44}
                    }
                    onMouseEnter={() => this.toggleHover("login")}
                    onMouseLeave={() => this.toggleHover("login")}
                  >
                    Sign in
                  </Link>
                  <Link
                    data-test-id={"signupbtn"}
                    to={pathName.includes('chef') ? "/sign-up-chef" : "/sign-up"}
                    key="register"
                    style={
                      this.state.registerHover
                        ? {...style.navMenuItemHover, marginRight: 0}
                        : {...style.navMenuItem, marginRight: 0}
                    }
                    onMouseEnter={() => this.toggleHover("register")}
                    onMouseLeave={() => this.toggleHover("register")}
                  >
                    Sign up
                  </Link>
                </Grid>
              </Hidden>

              <Hidden mdUp>
                <Drawer
                  open={this.state.openDrawer}
                  onClose={this.toggleDrawer}
                  anchor="left"
                >
                  <div tabIndex={0}>
                    <List style={style.sidebar}>
                      <ListItem>
                        <Link
                          to="/diner"
                          key="diner"
                          style={
                            this.state.dinerHover
                              ? style.navMenuItemHoverMobile
                              : style.mobileMenuItem
                          }
                          onMouseEnter={() => this.toggleHover("diner")}
                          onMouseLeave={() => this.toggleHover("diner")}
                        >
                          Diner
                        </Link>
                      </ListItem>
                      <Divider />
                      <ListItem>
                        <Link
                          to="/chef"
                          key="chef"
                          style={
                            this.state.chefHover
                              ? style.navMenuItemHoverMobile
                              : style.mobileMenuItem
                          }
                          onMouseEnter={() => this.toggleHover("chef")}
                          onMouseLeave={() => this.toggleHover("chef")}
                        >
                          Chef
                        </Link>
                      </ListItem>
                      <Divider />
                      <ListItem>
                        <a
                          href="https://cuisinecrafters.net/blog"
                          target="_blank"
                          key="blog"
                          style={
                            this.state.blogHover
                              ? style.navMenuItemHoverMobile
                              : style.mobileMenuItem
                          }
                          onMouseEnter={() => this.toggleHover("blog")}
                          onMouseLeave={() => this.toggleHover("blog")}
                        >
                          Blog
                        </a>
                      </ListItem>
                      <Divider />
                      <ListItem>
                        <Link
                          data-test-id={"loginbtn"}
                          to="/sign-in"
                          key="login"
                          style={
                            this.state.loginHover
                              ? {...style.navMenuItemHover, marginRight: 44, fontSize: 16}
                              : {...style.navMenuItem, marginRight: 44, fontSize: 16}
                          }
                          onMouseEnter={() => this.toggleHover("login")}
                          onMouseLeave={() => this.toggleHover("login")}
                        >
                          Sign in
                        </Link>
                      </ListItem>
                      <Divider />
                      <ListItem>
                        <Link
                            data-test-id={"signupbtn"}
                            to={pathName.includes('chef') ? "/sign-up-chef" : "/sign-up"}
                            key="register"
                            style={
                              this.state.registerHover
                                ? {...style.navMenuItemHover, marginRight: 0, fontSize: 16}
                                : {...style.navMenuItem, marginRight: 0, fontSize: 16}
                            }
                            onMouseEnter={() => this.toggleHover("register")}
                            onMouseLeave={() => this.toggleHover("register")}
                          >
                            Sign up
                          </Link>
                      </ListItem>
                      <Divider />
                    </List>
                  </div>
                </Drawer>
              </Hidden>

              {/*<LoginDrawer
                cancelChannelSignUp={this.cancelChannelSignUp}
                location={this.props.location}
                openLoginDrawer={this.state.openLoginDrawer}
                toggleLoginDrawer={this.toggleLoginDrawer}
                closeLoginDrawer={this.closeLoginDrawer}
                handleLoginToggle={this.handleLoginToggle}
                handleSignUpToggle={this.handleSignUpToggle}
                showLogin={this.state.showLogin}
                showSignUp={this.state.showSignUp}
                showForgotPassword={this.state.showForgotPassword}
              />*/}
            </div>
          </Grid>
        )}

        {userId && (
          <Grid container className='header-container' style={{
            position: 'fixed',
            width: '100%',
            left: 0,
            right: 0,
            zIndex: 999,
            backgroundColor: 'white',
            top: 0,
          }}>
            <div className="header-container-column">
              <Hidden mdUp xsDown>
                <Grid item xs={4} className='ipad-icon'>
                  <Icon style={style.menuIcon} onClick={this.toggleDrawer}>
                    menu
                  </Icon>
                </Grid>
              </Hidden>

              <Hidden only={["sm", "md", "lg", "xl"]}>
                <Grid item xs={4} className='ipad-icon'>
                  <Icon style={style.menuIcon} onClick={this.toggleDrawerMobile}>
                    menu
                  </Icon>
                </Grid>
              </Hidden>

              <Grid item xs={logoTabWidth} md={logoTabWidth} lg={logoWidth}>
                <Hidden only={["md", "lg", "xl"]}>
                  <img
                    src="/images/logo.webp"
                    alt="Cuisine Crafters"
                    style={style.logoMobile}
                    onClick={this.handleLogoClick}
                  />
                </Hidden>
                <Hidden smDown>
                  <img
                    src="/images/logo.webp"
                    alt="Cuisine Crafters"
                    style={style.logo}
                    onClick={this.handleLogoClick}
                  />
                </Hidden>
              </Grid>

              <Hidden smDown>
                <Grid item sm={8} md={8} lg={menuWidth} style={style.navMenu} justify={'flex-end'} alignContent={'center'}>
                  {(!isChef && pathName !== '/profile/edit-profile' && pathName !== '/become-chef' )&&
                  (<Link
                  data-test-id={"becochef-id"}
                      to="/home/become-chef"
                      key="becomeChef"
                      style={
                        this.state.dinerHover
                          ? style.navMenuItemHover
                          : style.navMenuItem
                      }
                      onMouseEnter={() => this.toggleHover("diner")}
                      onMouseLeave={() => this.toggleHover("diner")}
                    >
                      Become a chef
                    </Link>)
                  }
                  {isChef && showPortfolio && (
                    <Link
                    data-test-id={"portfoliolnk"}
                      to="/home/dashboard"
                      key="portfolio"
                      style={
                        this.state.dinerHover
                          ? style.navMenuItemHover
                          : style.navMenuItem
                      }
                      onMouseEnter={() => this.toggleHover("diner")}
                      onMouseLeave={() => this.toggleHover("diner")}
                    >
                      Portfolio
                    </Link>
                  )}
                  {!isChef && (
                    <Link
                      to="/home/saved"
                      key="saved"
                      style={
                        this.state.chefHover || this.props.history.location.pathname.toString().indexOf('saved') > -1
                          ? style.navMenuItemHover
                          : style.navMenuItem
                      }
                      onMouseEnter={() => this.toggleHover("chef")}
                      onMouseLeave={() => this.toggleHover("chef")}
                    >
                      Saved
                    </Link>
                  )}
                  {isChef && step > 3 && (
                    <Link
                    data-test-id={"linksch"}
                      to="/home/chef-schedule"
                      key="chef-schedule"
                      style={
                        this.state.chefHover
                          ? style.navMenuItemHover
                          : style.navMenuItem
                      }
                      onMouseEnter={() => this.toggleHover("chef")}
                      onMouseLeave={() => this.toggleHover("chef")}
                    >
                      Schedule
                    </Link>
                  )}
                  <Link
                  data-test-id={"linkbkgs"}
                    to={isChef ? "/home/chef-bookings" : "/home/diner-bookings"}
                    key="bookings"
                    style={
                      this.state.blogHover
                        ? style.navMenuItemHover
                        : style.navMenuItem
                    }
                    onMouseEnter={() => this.toggleHover("blog")}
                    onMouseLeave={() => this.toggleHover("blog")}
                  >
                    Bookings
                  </Link>
                  <a
                    data-test-id={"gethelp"}
                    href='https://cuisinecrafters.freshdesk.com/support/home'
                    key="get-help"
                    style={this.state.helpHover ? style.navMenuItemHover : style.navMenuItem}
                    target={'_blank'}
                    onMouseEnter={() => this.toggleHover("help")}
                    onMouseLeave={() => this.toggleHover("help")}
                  >
                    Help
                  </a>
                  {/*<Link
                    data-test-id={"linkinbox"}
                    to="/inbox"
                    key="inbox"
                    style={
                      this.state.loginHover
                        ? style.navMenuItemHover
                        : style.navMenuItem
                    }
                    onMouseEnter={() => this.toggleHover("login")}
                    onMouseLeave={() => this.toggleHover("login")}
                  >
                    Inbox
                  </Link>*/}
                  {/*<Link*/}
                  {/*  to="/"*/}
                  {/*  key="logout"*/}
                  {/*  style={*/}
                  {/*    this.state.logoutHover*/}
                  {/*      ? style.navMenuItemHover*/}
                  {/*      : style.navMenuItem*/}
                  {/*  }*/}
                  {/*  onMouseEnter={() => this.toggleHover("logout")}*/}
                  {/*  onMouseLeave={() => this.toggleHover("logout")}*/}
                  {/*  onClick={this.logout}*/}
                  {/*>*/}
                  {/*  Logout*/}
                  {/*</Link>*/}
                  <div style={{marginTop:7}}>
                    <Button
                      data-test-id={"profile"}
                      buttonRef={node => {
                        this.anchorEl = node;
                      }}
                      aria-owns={open ? "menu-list-grow" : undefined}
                      aria-haspopup="true"
                      onClick={this.handleToggle}
                      style={{ backgroundColor: 'transparent', minWidth: 36, padding: 0 }}
                    >
                      <Avatar
                        src={profilePic}
                        alt="Image not available"
                        style={style.avatarImg}
                      />
                    </Button>
                    <Popper
                      open={open}
                      style={{ zIndex: 77777 }}
                      anchorEl={this.anchorEl}
                      transition
                      disablePortal
                    >
                      {({ TransitionProps, placement }) => (
                        <Grow
                          {...TransitionProps}
                          id="menu-list-grow"
                          style={{
                            /*transformOrigin:
                              placement === "bottom"
                                ? "top"
                                : "bottom"*/
                          }}
                        >
                          <Paper>
                            <ClickAwayListener onClickAway={this.handleClose}>
                              <MenuList className="header-user-menu">
                                <MenuItem onClick={this.handleClose}>
                                  <Link
                                  data-test-id={"editprof-id"}
                                    to="/home/profile/edit-profile"
                                    key="edit-profile"
                                    style={style.stepSelected}
                                  >
                                    Edit profile
                                  </Link>
                                </MenuItem>
                                {!isChef && (
                                  <MenuItem onClick={this.handleClose}>
                                    <Link
                                    data-test-id={"kitchen-id"}
                                      to="/home/profile/my-kitchen"
                                      key="my-kitchen"
                                      style={style.stepSelected}
                                    >
                                      My kitchen
                                    </Link>
                                  </MenuItem>
                                )}
                                  <MenuItem onClick={this.handleClose}>
                                    <Link
                                    data-test-id={"profpymt-id"}
                                      to="/home/profile/payment-info"
                                      key="payment-info"
                                      style={style.stepSelected}
                                    >
                                      Payment info.
                                    </Link>
                                  </MenuItem>
                                {isChef && (
                                  <MenuItem onClick={this.handleClose}>
                                    <Link
                                    data-test-id={"chefpymt-id"}
                                      to="/home/profile/chef-payment-info"
                                      key="chef-payment-info"
                                      style={style.stepSelected}
                                    >
                                      <span>Payout info.</span>
                                      <ListItemIcon style={{ marginBottom: -10 }}>
                                        {!!chef && !chef.payoutInfoExists && !chef.payoutMethod && <Icon style={style.errorIcon}>
                                          error
                                        </Icon>}
                                      </ListItemIcon>
                                    </Link>
                                  </MenuItem>
                                )}
                                {isChef && (
                                  <MenuItem onClick={this.handleClose}>
                                    <Link
                                      to="/home/profile/accounting"
                                      key="chef-transactions"
                                      style={style.stepSelected}
                                    >
                                      Accounting
                                    </Link>
                                  </MenuItem>
                                )}
                                {isChef && <MenuItem onClick={this.handleClose}>
                                  <Link
                                      data-test-id={"editfb-id"}
                                      to="/home/profile/feedback"
                                      key="feedback"
                                      style={style.stepSelected}
                                  >
                                    Reach us
                                  </Link>
                                </MenuItem>}
                                {isChef && (
                                  <MenuItem onClick={this.handleClose}>
                                    <Link
                                      to="/home/profile/cancelation-policy"
                                      key="chef-transactions"
                                      style={style.stepSelected}
                                    >
                                      Cancelation policy
                                    </Link>
                                  </MenuItem>
                                )}
                                {isChef && (
                                  <MenuItem onClick={this.handleClose}>
                                    <Link
                                      to="/home/profile/subscription"
                                      key="chef-subscriptions"
                                      style={style.stepSelected}
                                      data-test-id="menu-subscription-link"
                                    >
                                      Subscription
                                    </Link>
                                  </MenuItem>
                                )}
                              {/* <MenuItem onClick={this.handleClose}>
                                  <Link
                                    to="/profile/invite-friends"
                                    key="invite-friends"
                                    style={style.stepSelected}
                                  >
                                    Invite friends
                                  </Link>
                                </MenuItem>*/}
                                {!isChef && <MenuItem onClick={this.handleClose}>
                                  <Link
                                      data-test-id={"editfb-id"}
                                      to="/home/profile/feedback"
                                      key="feedback"
                                      style={style.stepSelected}
                                  >
                                    Reach us
                                  </Link>
                                </MenuItem>}

                                <MenuItem onClick={this.handleClose}>
                                  <Link
                                  data-test-id={"logout-id"}
                                      to="/"
                                      key="logout"
                                      style={style.stepSelected}
                                      onMouseEnter={() => this.toggleHover("logout")}
                                      onMouseLeave={() => this.toggleHover("logout")}
                                      onClick={this.logout}
                                  >
                                    Logout
                                  </Link>
                                </MenuItem>
                              </MenuList>

                            </ClickAwayListener>
                          </Paper>
                        </Grow>
                      )}
                    </Popper>
                  </div>
                </Grid>
              </Hidden>

              <Hidden only={["sm", "md", "lg", "xl"]}>
                <Drawer
                  open={this.state.openDrawerMobile}
                  onClose={this.toggleDrawerMobile}
                  anchor="left"
                >
                  <div tabIndex={0}>
                    <List style={style.sidebar}>

                      {!isChef && (
                        <ListItem onClick={() => this.handleBtnClick("becomeChef")}>
                          <ButtonBase
                            data-test-id={"becomechef-id"}
                            key="becomeChef"
                            style={
                              this.state.dinerHover
                                ? style.navMenuItemHover
                                : style.mobileMenuItem
                            }
                            onMouseEnter={() => this.toggleHover("diner")}
                            onMouseLeave={() => this.toggleHover("diner")}
                          >
                            Become a chef
                          </ButtonBase>
                        </ListItem>
                      )}
                      <Divider />
                      <ListItem  onClick={() => {
                        const { dispatch } = this.props;
                        dispatch(logoutUser());
                        // this.toggleDrawer();
                        this.props.history.push("/");
                      }}>
                        <ButtonBase
                          key="logout"
                          style={
                            this.state.loginHover
                              ? style.navMenuItemHover
                              : style.mobileMenuItem
                          }
                          onMouseEnter={() => this.toggleHover("logout")}
                          onMouseLeave={() => this.toggleHover("logout")}
                        >
                          Logout
                        </ButtonBase>
                      </ListItem>

                    </List>
                  </div>
                </Drawer>
              </Hidden>

              <Hidden only={["xs", "lg", "xl"]}>
                <Drawer
                  open={this.state.openDrawer}
                  onClose={this.toggleDrawer}
                  anchor="left"
                >
                  <div tabIndex={0}>
                    <List style={style.sidebar}>

                        {!isChef && (
                            <ListItem onClick={() => this.handleBtnClick("becomeChef")}>
                          <ButtonBase
                          data-test-id={"becomechef-id"}
                            key="becomeChef"
                            style={
                              this.state.dinerHover
                                ? style.navMenuItemHover
                                : style.mobileMenuItem
                            }
                            onMouseEnter={() => this.toggleHover("diner")}
                            onMouseLeave={() => this.toggleHover("diner")}
                          >
                            Become a chef
                          </ButtonBase>
                            </ListItem>
                        )}
                        {isChef && showPortfolio && (
                            <ListItem onClick={() => this.handleBtnClick("portfolio")}>
                            <ButtonBase

                          key="portfolio"
                          style={
                          this.state.blogHover
                          ? style.navMenuItemHoverMobile
                          : style.mobileMenuItem
                        }
                          onMouseEnter={() => this.toggleHover("diner")}
                          onMouseLeave={() => this.toggleHover("diner")}
                          >
                          Portfolio
                          </ButtonBase>
                            </ListItem>
                        )}
                      <Divider />
                        {!isChef && (
                            <ListItem onClick={() => this.handleBtnClick("saved")}>
                          <ButtonBase
                          data-test-id={"saved-id"}
                            key="saved"
                            style={
                              this.state.chefHover || this.props.history.location.pathname.toString().indexOf('saved') > -1
                                ? style.navMenuItemHover
                                : style.mobileMenuItem
                            }
                            onMouseEnter={() => this.toggleHover("chef")}
                            onMouseLeave={() => this.toggleHover("chef")}
                          >
                            Saved
                          </ButtonBase>
                            </ListItem>
                        )}
                        {isChef && step > 3 && (
                            <ListItem   onClick={() => this.handleBtnClick("schedule")}>
                          <ButtonBase
                            key="schedule"
                            style={
                              this.state.chefHover
                                ? style.navMenuItemHover
                                : style.mobileMenuItem
                            }
                            onMouseEnter={() => this.toggleHover("chef")}
                            onMouseLeave={() => this.toggleHover("chef")}
                          >
                            Schedule
                          </ButtonBase>
                            </ListItem>
                        )}
                      <Divider />
                      <ListItem    onClick={() => this.handleBtnClick("bookings")}>
                        <ButtonBase
                          data-test-id={"dinerbkgs-id"}
                          key="bookings"
                          style={
                            this.state.blogHover
                              ? style.navMenuItemHover
                              : style.mobileMenuItem
                          }
                          onMouseEnter={() => this.toggleHover("blog")}
                          onMouseLeave={() => this.toggleHover("blog")}
                        >
                          Bookings
                        </ButtonBase>
                      </ListItem>
                      <Divider />
                      {/*<ListItem      onClick={() => this.handleBtnClick("inbox")}>
                        <ButtonBase

                          key="inbox"
                          style={
                            this.state.loginHover
                              ? style.navMenuItemHover
                              : style.mobileMenuItem
                          }
                          onMouseEnter={() => this.toggleHover("login")}
                          onMouseLeave={() => this.toggleHover("login")}
                        >
                          Inbox
                        </ButtonBase>
                      </ListItem>
                      <Divider />*/}
                      <ListItem      onClick={() => this.handleBtnClick("profile")}>
                        <ButtonBase

                          key="profile"
                          style={
                            this.state.loginHover
                              ? style.navMenuItemHover
                              : style.mobileMenuItem
                          }
                          onMouseEnter={() => this.toggleHover("profile")}
                          onMouseLeave={() => this.toggleHover("profile")}
                        >
                          Profile
                        </ButtonBase>
                      </ListItem>
                      <Divider />
                        <ListItem  onClick={() => {
                            const { dispatch } = this.props;
                            dispatch(logoutUser());
                            // this.toggleDrawer();
                            this.props.history.push("/");
                        }}>
                            <ButtonBase
                                key="logout"
                                style={
                                    this.state.loginHover
                                        ? style.navMenuItemHover
                                        : style.mobileMenuItem
                                }
                                onMouseEnter={() => this.toggleHover("logout")}
                                onMouseLeave={() => this.toggleHover("logout")}
                            >
                                Logout
                            </ButtonBase>
                        </ListItem>

                    </List>
                  </div>
                </Drawer>
              </Hidden>

              {/*<LoginDrawer
                cancelChannelSignUp={this.cancelChannelSignUp}
                location={this.props.location}
                openLoginDrawer={this.state.openLoginDrawer}
                toggleLoginDrawer={this.toggleLoginDrawer}
                closeLoginDrawer={this.closeLoginDrawer}
                handleLoginToggle={this.handleLoginToggle}
                handleSignUpToggle={this.handleSignUpToggle}
                showLogin={this.state.showLogin}
                showSignUp={this.state.showSignUp}
                showForgotPassword={this.state.showForgotPassword}
              />*/}
            </div>
          </Grid>
        )}
        <ResetPasswordDrawer
          openPasswordDrawer={openPasswordDrawer}
          closeLoginDrawer={this.closePasswordDrawer}
          toggleLoginDrawer={this.togglePasswordDrawer}
          history={this.props.history}
        />
        {loading && <LinearProgress color="primary" />}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    userId: state.auth.userId,
    isChef: state.auth.isChef,
    becomeChef: state.auth.becomeChef,
    step: state.auth.step,
    diner: state.user.diner,
    chef: state.user.chef,
    forceChangePassword: state.auth.forceChangePassword,
    showBecomeChefMsg: state.auth.showBecomeChefMsg,
  };
};

const Header = connect(mapStateToProps)(HeaderComponent);

export default Header;
